import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { EnumTipoQuestionarioUG } from '../models/enum/tipo-questionario-ug.enum';
import { ISalvarAlocarEquipeModel } from "../models/alocar-equipe-component";
import { IOsaModel } from "../models/osa-model";

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private unidadeGestoraId: number;
  private universoAuditavelId: number;
  private tipoUniversoAuditavelId: number;
  private salvarEventSubject  = new Subject<void>();
  private validacaoRequestSubject = new Subject<void>();
  private validacaoResponseSubject = new Subject<{sucesso: boolean, mensagem?: string}>();
  private tipoQuestionario: EnumTipoQuestionarioUG;
  private modoVisualizarTelaUnidadeGestora : boolean;
  private dadosEquipeNovaVersaoSource = new BehaviorSubject<ISalvarAlocarEquipeModel[] | null>(null);
  private sincronizarDadosSubject = new Subject<void>();
  private modelAtualizadoSubject = new Subject<IOsaModel>();
  private planejamentoIdSource = new BehaviorSubject<number>(null);
  public planejamentoId: Observable<number> = this.planejamentoIdSource.asObservable();
  private numeroOsaSource = new BehaviorSubject<string>(null);
  private nomeUg = new BehaviorSubject<string>(null);
  public numeroOsa: Observable<string> = this.numeroOsaSource.asObservable();
  private dataFimRealizacaoSource = new BehaviorSubject<Date>(null);
  private nomeAuditorSource = new BehaviorSubject<string>(null);
  private nomeAuditorIdSource = new BehaviorSubject<string>(null);
  public dataFimRealizacao: Observable<Date> = this.dataFimRealizacaoSource.asObservable();
  public nomeAuditor: Observable<string> = this.nomeAuditorSource.asObservable();
  public auditorId: Observable<string> = this.nomeAuditorIdSource.asObservable();

  private statusOsaExecucaoSource = new BehaviorSubject<number>(null);
  public statusOsaExecucaoSo: Observable<number> = this.statusOsaExecucaoSource.asObservable();

  private statusManifestacaoSource = new BehaviorSubject<number | null>(null);
  public statusManifestacao$: Observable<number | null> = this.statusManifestacaoSource.asObservable();
  private statusMatrizPreliminarSource = new BehaviorSubject<number | null>(null);
  public statusMatrizPreliminar$: Observable<number | null> = this.statusMatrizPreliminarSource.asObservable();

  setStatusManifestacao(status: number | null): void {
    this.statusManifestacaoSource.next(status);
  }

  setStatusMatrizPreliminar(status: number | null): void {
    this.statusMatrizPreliminarSource.next(status);
  }

  getStatusMatrizPreliminar(): number | null {
    return this.statusMatrizPreliminarSource.getValue();
  }

  getStatusManifestacao(): number | null {
    return this.statusManifestacaoSource.getValue();
  }

  setPlanejamentoId(id: number) {
    this.planejamentoIdSource.next(id);
  }

  setstatusOsaExecucao(id: number) {
    this.statusOsaExecucaoSource.next(id);
  }

  getstatusOsaExecucao(): number {
    return this.statusOsaExecucaoSource.value;
  }
  getPlanejamentoId(): number {
    return this.planejamentoIdSource.value;
  }
  setNumeroOsa(id: string) {
    this.numeroOsaSource.next(id);
  }
  setNomeUG(id: string) {
    this.nomeUg.next(id);
  }

  setAuditorId(id: string) {
    this.nomeAuditorIdSource.next(id);
  }

  setNomeAuditor(nome: string) {
    this.nomeAuditorSource.next(nome);
  }

  getNomeAuditor(): string {
    return this.nomeAuditorSource.getValue();
  }
  getNomeAuditorId(): string {
    return this.nomeAuditorIdSource.getValue();
  }


  getNumeroOsa(): string {
    return this.numeroOsaSource.getValue();
  }
  getNomeUG(): string {
    return this.nomeUg.getValue();
  }


 setDataFimRealizacao(id: Date) {
    this.dataFimRealizacaoSource.next(id);
  }

  getDataFimRealizacao(): Date {
    return this.dataFimRealizacaoSource.getValue();
  }


  sendSincronizarDadosEvent() {
    this.sincronizarDadosSubject.next();
  }

  getSincronizarDadosEvent(): Observable<void> {
    return this.sincronizarDadosSubject.asObservable();
  }
  sendSalvarEvent() {
    this.salvarEventSubject.next();
  }

  getEvent() {
    return this.salvarEventSubject.asObservable();
  }

  sendValidacaoRequest() {
    this.validacaoRequestSubject.next();
  }

  getValidacaoRequest() {
    return this.validacaoRequestSubject.asObservable();
  }

  sendValidacaoResponse(sucesso: boolean, mensagem?: string) {
    this.validacaoResponseSubject.next({sucesso, mensagem});
  }

  getValidacaoResponse() {
    return this.validacaoResponseSubject.asObservable();
  }

  sendModelAtualizado(model: IOsaModel) {
    this.modelAtualizadoSubject.next(model);
  }

  getModelAtualizado(): Observable<IOsaModel> {
    return this.modelAtualizadoSubject.asObservable();
  }

  setParams(unidadeGestoraId: number, universoId: number, tipouniversoId: number, acao: string): void {
    const chave = 'params';

    // Remove se já existir
    if (localStorage.getItem(chave)) {
      localStorage.removeItem(chave);
    }

    // Cria o novo item
    const params = {
      unidadeGestoraId: unidadeGestoraId,
      universoId: universoId,
      tipouniversoId: tipouniversoId,
      acao: acao
    };

    localStorage.setItem(chave, JSON.stringify(params));
  }

  setParamsRiscos(subtipo: string, macroprocesso: string, processo: string): void {
    const chave = 'paramsRiscos';

    // Remove se já existir
    if (localStorage.getItem(chave)) {
      localStorage.removeItem(chave);
    }

    // Cria o novo item
    const params = {
      subtipo: subtipo,
      macroprocesso: macroprocesso,
      processo: processo
    };

    localStorage.setItem(chave, JSON.stringify(params));
  }

  getParams(): any {
    const params = localStorage.getItem('params');
    return params ? JSON.parse(params) : null;
  }
  getParamsRiscos(): any {
    const params = localStorage.getItem('paramsRiscos');
    return params ? JSON.parse(params) : null;
  }



  setId(id: number) {
    this.unidadeGestoraId = id;
  }

  getId(): number {
    return this.unidadeGestoraId;
  }

  setTipoQuestionario(tipo: EnumTipoQuestionarioUG){
    this.tipoQuestionario = tipo;
  }

  getTipoQuestionario(): EnumTipoQuestionarioUG{
    return this.tipoQuestionario;
  }

  setModoVisualizacaoAbasUnidadeGestora(modoVisualizacao: boolean) {
    this.modoVisualizarTelaUnidadeGestora = modoVisualizacao;
  }

  getModoVisualizacaoAbasUnidadeGestora() : boolean {
    return this.modoVisualizarTelaUnidadeGestora;
  }


  sendDadosEquipeNovaVersao(dados: ISalvarAlocarEquipeModel[] | null) {
    this.dadosEquipeNovaVersaoSource.next(dados);
  }

  getDadosEquipeNovaVersaoValue(): ISalvarAlocarEquipeModel[] | null {
    return this.dadosEquipeNovaVersaoSource.value;
  }
}
